import { render, staticRenderFns } from "./PortEditAcceptedRequests.vue?vue&type=template&id=17351c20&scoped=true"
import script from "./PortEditAcceptedRequests.vue?vue&type=script&lang=js"
export * from "./PortEditAcceptedRequests.vue?vue&type=script&lang=js"
import style0 from "./PortEditAcceptedRequests.vue?vue&type=style&index=0&id=17351c20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17351c20",
  null
  
)

export default component.exports